import React, { Suspense } from 'react';
import { css } from '@emotion/react';

import isMobile from '$/utils/isMobile';
import { RoomType } from '$/GraphQL/schema/schema';

import {
  staticWebinarDimensions,
  withWebinarPlayerContext,
} from '$/components/WebinarPlayer/context';

const EditPlaybackControlsBar = React.lazy(() => import('./EditPlaybackControlsBar'));
const SessionVideoControlsBar = React.lazy(() => import('./SessionVideoControlsBar'));

export const VideoControlsBar: React.FC<{ overVideo: boolean }> = withWebinarPlayerContext([
  'editMode',
  'currentRoom',
  'dimensions',
  'hasAgenda',
  'isCollapsedEmbeddedPlayer',
])(({ overVideo, context }) => {
  const { editMode, currentRoom, dimensions } = context;

  if (
    (!overVideo &&
      dimensions.videoControlsArea.bottomBar.height === 0 &&
      currentRoom.type !== RoomType.Exit) ||
    currentRoom.type === RoomType.PostExit
  ) {
    return null;
  }

  return (
    <div
      className={`VideoControlsBar
        flex z-player-control-bar justify-between items-center bottom-bar
        actions-${dimensions.actionsPane.location}
        ${isMobile ? 'is-mobile' : ''}
      `}
      css={css`
        position: absolute;
        pointer-events: none;
        opacity: ${context.isCollapsedEmbeddedPlayer ? '0' : '1'};
        bottom: ${dimensions.videoControlsArea.bottomBar.paddingY}px;
        left: ${dimensions.videoControlsArea.bottomBar.paddingX}px;

        min-height: ${
          staticWebinarDimensions.videoControlsArea.bottomBar.height -
          dimensions.videoControlsArea.bottomBar.paddingY * 2
        }px;
        width: ${
          dimensions.webinarArea.width -
          dimensions.actionsPane.maxWidthRem * 14 - // Use maxWidth as we never want to be wide
          dimensions.videoControlsArea.bottomBar.paddingX * 2
        }px;

        .control {
          display: flex;
          align-items: center;
          color: #000;
          pointer-events: auto;
        }

        &:not(.actions-right) {
          width: ${
            dimensions.videoControlsArea.width - dimensions.videoControlsArea.bottomBar.paddingX * 2
          }px;

          &.is-mobile {
            .control {
              color: ${currentRoom.type === RoomType.Exit ? '#000' : '#fff'};
              .rc-slider-rail {
                background: rgba(255, 255, 255, 0.3);
              }
            }
          }
        }

        #leftControls,
        #rightControls {
          > * {
            margin-right: 0.5rem;
            margin-left: 0.5rem;
          }
        }

        .view-button {
          transition: transform 0.2s;
          &:hover:not([disabled]) {
          .touching {
            transform: scale(1.1);
          }
        }
      `}
    >
      <Suspense>
        {editMode === 'dash.chat' ? <EditPlaybackControlsBar /> : <SessionVideoControlsBar />}
      </Suspense>
    </div>
  );
});
